import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import App from './component/Container/App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// function injectDynamicManifest() {
//   const manifest = {
//     name: "Menu",
//     short_name: "Menu",
//     start_url: window.location.href,
//     scope: "/",
//     display: "standalone",
//     theme_color: "#000000",
//     background_color: "#ffffff",
//     icons: [
//       {
//         src: "/favicon.ico",
//         sizes: "64x64 32x32 24x24 16x16",
//         type: "image/x-icon"
//       },
//       {
//         src: "/logo192.png",
//         sizes: "192x192",
//         type: "image/png"
//       },
//       {
//         src: "/logo512.png",
//         sizes: "512x512",
//         type: "image/png"
//       }
//     ]
//   };

//   const stringManifest = JSON.stringify(manifest);
//   const blob = new Blob([stringManifest], { type: "application/json" });
//   const manifestURL = URL.createObjectURL(blob);

//   let link = document.querySelector("link[rel='manifest']");
//   if (!link) {
//     link = document.createElement("link");
//     link.rel = "manifest";
//     document.head.appendChild(link);
//   }
//   link.href = manifestURL;

// }

// injectDynamicManifest();
//remove monifest.json and remove link on index.html

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
    <Toaster containerStyle={{ fontSize: '.9rem' }} />
  </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
